import EventEmitter from 'eventemitter3'
import { getThemeColorsFromCSS } from 'app_utils/functions/getTheme'

const eventEmitter = new EventEmitter()

const Emitter = {
  on: (event: string, fn: any) => eventEmitter.on(event, fn),
  once: (event:string, fn:any) => eventEmitter.once(event, fn),
  off: (event:string, fn:any) => eventEmitter.off(event, fn),
  emit: (event:string, payload:any) => eventEmitter.emit(event, payload),
}

Object.freeze(Emitter)

/**
 * Emitir colores del tema al hook
 */
Emitter.on('get-colors', (event: string)=>Emitter.emit(event, getThemeColorsFromCSS()))

export default Emitter
